import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import * as routeActions from 'services/routes/actions'
import * as routeSelectors from 'services/routes/selectors'
import * as siteSelectors from 'services/site/selectors'
import { Grid, Row, Col } from 'react-flexbox-grid/lib'
import Toolbar from './Toolbar'
import Map from './Map'
import Elevation from './Elevation'
import Directions from './Directions'
import Meta from './Meta'
import styles from './_page.css'

const mapStateToProps = state => ({
  route: routeSelectors.selectRoute(state),
  site: siteSelectors.selectSite(state),
})

const mapDispatchToActions = { ...routeActions }

export class RoutePrintPage extends Component {

  static propTypes = {
    route: PropTypes.object,
    site: PropTypes.object,
    match: PropTypes.object,
    fetchDetailedInternalRoute: PropTypes.func.isRequired,
  };

  state = {
    showElevation: true,
    showMap: true,
    showDirections: true,
  }

  componentDidMount () {
    const { routeId } = this.props.match.params
    const { fetchDetailedInternalRoute } = this.props
    fetchDetailedInternalRoute(routeId)
  }

  toggleElevation = () => {
    this.setState({ ...this.state, showElevation: !this.state.showElevation })
  }

  toggleMap = () => {
    this.setState({ ...this.state, showMap: !this.state.showMap })
  }

  toggleDirections = () => {
    this.setState({ ...this.state, showDirections: !this.state.showDirections })
  }

  print () {
    window.print()
  }

  render () {
    const { showMap, showElevation, showDirections } = this.state
    const { route, site } = this.props
    const { routeId } = this.props.match.params
    return (
      <section className={styles.page}>
        <Toolbar
          toggleElevation={this.toggleElevation}
          toggleMap={this.toggleMap}
          toggleDirections={this.toggleDirections}
          showElevation={showElevation}
          showMap={showMap}
          showDirections={showDirections}
          print={this.print} />
        <section className={styles.container}>
          <Grid>
            <Row>
              <Col xs={10} xsOffset={1} lg={8} lgOffset={2}>
                <section className={styles.printArea}>
                  {route ? <Meta route={route} site={site} /> : null}
                  {showMap ? <Map routeId={routeId} /> : null}
                  {showElevation ? <Elevation routeId={routeId} /> : null}
                  {showDirections && route ? <Directions /> : null}
                </section>
              </Col>
            </Row>
          </Grid>
        </section>
      </section>
    )
  }
}

export const Page = injectIntl(RoutePrintPage)
export default connect(mapStateToProps, mapDispatchToActions)(withRouter(Page))
